import { render, staticRenderFns } from "./productpricing.vue?vue&type=template&id=7b2bac46&scoped=true&"
import script from "./productpricing.vue?vue&type=script&lang=js&"
export * from "./productpricing.vue?vue&type=script&lang=js&"
import style0 from "./productpricing.vue?vue&type=style&index=0&id=7b2bac46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2bac46",
  null
  
)

export default component.exports